import { getFutureDates, getTimezoneInfo } from "./dates";

// utils/clubs.ts
export function addMultiClubDatesUtil({ dates, multiDates, timezone }: { dates: { value: any[] }; multiDates: { value: any }; timezone: { value: string } }) {
  const inputDate = dates.value[dates.value.length - 1]?.date ? new Date(dates.value[dates.value.length - 1].date) : new Date();
  const futureDates = getFutureDates(inputDate, multiDates.value.day, multiDates.value.amount, timezone.value);

  if (!dates.value[0]?.date) {
    dates.value.splice(0, 1);
  }

  futureDates.forEach(futureDate => {
    const { short_timezone, timezone_offset } = getTimezoneInfo(futureDate, timezone.value);

    if(dates.value.some(date => new Date(date.date).toISOString() === new Date(futureDate).toISOString())) {
      console.log("Duplicate date found, skipping:", futureDate);
      return;
    }

    dates.value.push({
      end_time: multiDates.value.end_time,
      date: futureDate,
      start_time: multiDates.value.start_time,
      timezone: timezone.value,
      short_timezone: short_timezone,
      timezone_offset: timezone_offset,
    });
  });

  // Sort dates by date
  dates.value.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  // Ensure no duplicates
  dates.value = dates.value.filter((date, index, self) => {
    return index === self.findIndex(d => new Date(d.date).toISOString() === new Date(date.date).toISOString());
  });

  // If we've removed a duplicate date, add one back to the end of the array
  if (dates.value.length - 1 < multiDates.value.amount) {
    const lastDate = new Date(dates.value[dates.value.length - 1].date);
    const nextDate = new Date(lastDate.getTime() + multiDates.value.day * 24 * 60 * 60 * 1000);

    const { short_timezone, timezone_offset } = getTimezoneInfo(nextDate.toISOString(), timezone.value);

    dates.value.push({
      end_time: multiDates.value.end_time,
      date: nextDate,
      start_time: multiDates.value.start_time,
      timezone: timezone.value,
      short_timezone: short_timezone,
      timezone_offset: timezone_offset,
    });
  }

  return dates.value;
}
